export default __webpack_public_path__ + "static/media/img3.75f3deec.png";